z<template>
<div>
 <div class="md-layout-item md-size-100">

 <CDataTable
                              :items="speciesItem"
                              :fields="fields"
                              pagination
                              table-filter
                              items-per-page-select
                              :items-per-page="10"
                              clickable-rows
                              hover
                              @row-clicked="rowClicked"
                            
                              caption="Species"
 

                             
                            />
  <div class="ui-theme-settings" >
     <CButton
      type="button"
      class="btn-open-options btn btn-warning"
      v-bind:class="{ 'is-active' : isConfigOpen }"
      @click="toggleConfig('settings-open')"
    >
     <img src="img/cross.svg" class="svg" style="width:20px"  v-if="isConfigOpen" />
    <!-- <CIcon name="cilPencil" style="color:white"  v-if="isConfigOpen" ></CIcon> -->
      <!-- <md-icon style="color:white" v-if="isConfigOpen">arrow_forward</md-icon> -->
      <!-- <md-icon style="color:white" v-if="!isConfigOpen">arrow_back</md-icon> -->
      <img src="img/pencil.svg" class="svg" style="width:20px"  v-if="!isConfigOpen"/>
    </CButton>
    <div class="theme-settings__inner">
      <div class="md-layout" style="background-color:#425276;color: #fff;font: icon;">
       
        <div
          class="md-layout-item md-size-60"
          style="padding-left:0px !important;margin-top: auto;margin-bottom:auto;"
        >
          <!-- <span
            style="float:left;font-weight:400;text-transform: capitalize;"
          >{{this.user.firstName}} {{this.user.lastName}}</span> -->
          <br />
          <!-- <span style="font-size:13px;">Punched-in @ 09:35 am</span>
          <br />-->
          <!-- <span style="font-size:13px;">
            Madurai @ 09:35:00 am
          </span>-->
        </div>
        <div class="md-layout-item md-size-25" style="text-align: right;padding-right: 30px;">
          <!-- <img class="my-icon" style="width:40px;float:right;" src="/img/phone.svg" /> -->
          <md-icon style="color: #CFD8DC;font-size: 30px !important;">devices_other</md-icon>
        </div>
        <div class="md-layout-item md-size-100">
          <hr />
        </div>
        <!-- <div class="md-layout-item md-size-25" style="margin-bottom: 5px;">
          <radial-progress-bar
            :diameter="100"
            :completed-steps="completedSteps"
            :total-steps="totalSteps"
            :strokeWidth="3"
          >
            <p style="color:#fff;margin:0;">
              <b>{{ completedSteps }}</b>%
            </p>
            <p style="color:#fff;margin:0;margin-top:5px;">
              FTR
            
            </p>
          </radial-progress-bar>
        </div> -->
        <div class="md-layout-item md-size-5 vl" style="padding:0;margin-right:-25px !important;"></div>
        <div class="md-layout-item md-size-25" style="text-align:center;">
          <p style="margin:0; margin-top:10px;">
            <!-- <md-icon style="color: #CFD8DC;">date_range</md-icon> -->
          </p>
          <p style="margin:0;margin-top:10px;">{{this.visitCount}} Visits</p>
          <!-- <p style="margin:0;margin-top:5px;">0 min</p> -->
        </div>
        <div class="md-layout-item md-size-25" style="text-align:center;">
          <p style="margin:0;margin-top:10px;">
            <!-- <md-icon style="color: #CFD8DC;">timeline</md-icon> -->
          </p>
          <!-- <p style="margin:0;margin-top:10px;">{{ visitkms }} kms</p> -->
          <!-- <p style="margin:0;margin-top:5px;">{{visitmin}} min</p> -->
        </div>
        <div class="md-layout-item md-size-20" style="text-align:center;">
          <p style="margin:0;margin-top:10px;">
            <!-- <md-icon style="color: #CFD8DC;">business</md-icon> -->
          </p>
          <!-- <p style="margin:0;margin-top:10px;">Office</p> -->
          <!-- <p style="margin:0;margin-top:5px;">0 min</p> -->
        </div>
      </div>
      <div class="md-layout">
        <div class="md-layout-item md-size-100">
          

                <CCol col="6" md="12">
                  
                        <!-- <button @click="isShowing ^= true">Click Me</button> -->
                        <CCard class="clr"  >
                          <CCardBody>
                            <CForm  >
                              <CInput
                                label="Live Weight(Kg) From"
                                name="liveWeightfrom"
                                id="liveWeightfrom"
                                required
                                horizontal
                                autocomplete="name"
                                size="25"
                                v-model="liveWeightfrom"
                              />

                              <CInput
                                label="Live Weight(Kg) To"
                                name="liveWeightto"
                                id="liveWeightto"
                                required
                                horizontal
                                autocomplete="name"
                                v-model="liveWeightto"
                              />
                              <CInput
                                label="Dry"
                                name="dry"
                                id="dry"
                                required
                                horizontal
                                autocomplete="name"
                                v-model="dry"
                              />
                              <CInput
                                label="S.P.Foode"
                                name="s_p_fodder"
                                id="s_p_fodder"
                                required
                                horizontal
                                autocomplete="name"
                                v-model="s_p_fodder"
                              />
                              <!-- <CInput label="DRY M" name="breedName" id="breedName" required horizontal autocomplete="name" v-model="s_p_fodder"/> -->
                              <CInput
                                label="DRY M1"
                                name="dryM1"
                                id="dryM1"
                                required
                                horizontal
                                autocomplete="name"
                                v-model="dryM1"
                              />
                              <CInput
                                label="DRY M2"
                                name="dryM2"
                                id="dryM2"
                                required
                                horizontal
                                autocomplete="name"
                                v-model="dryM2"
                              />
                              <CInput
                                label="DRY M3"
                                name="dryM3"
                                id="dryM3"
                                required
                                horizontal
                                autocomplete="name"
                                v-model="dryM3"
                              />
                              <CInput
                                label="Green Fodder"
                                name="greenFodder"
                                id="greenFodder"
                                required
                                horizontal
                                autocomplete="name"
                                v-model="greenFodder"
                              />
                            </CForm>
                          </CCardBody>

                          <CCardFooter>
                            <CButton
                              color="info"
                              style="width:100px"
                              v-if="addButton"
                              @click="addSpecies"
                            >
                              <CIcon name="cilPencil" />&nbsp;Add
                            </CButton>&nbsp;
                            <CButton
                              color="success"
                              style="width:100px"
                              v-if="saveButton"
                              @click="updateSpecies"
                            >
                              <CIcon name="cilCheck" />&nbsp;Save
                            </CButton>&nbsp;
                            <CButton
                              color="success"
                              style="width:100px"
                              v-if="EditsaveButton"
                              @click="addSpecies"
                            >
                              <CIcon name="cilCheck" />&nbsp;Save
                            </CButton>&nbsp;
                            <CButton
                              color="danger"
                              style="width:100px"
                              v-if="deleteButton"
                              @click="deleteSpecies"
                            >
                              <CIcon name="cilXCircle" />&nbsp;Delete
                            </CButton>
&nbsp;
                            <CButton
                              color="secondary"
                              style="width:100px"
                              v-if="cancelButton"
                              @click="Cancelspecies"
                            >
                              <CIcon name="cilWarning" />&nbsp;Cancel
                            </CButton>

                            <CButton color="info" v-if="addnewButton" @click="addNewspecies">
                              <CIcon name="cilPencil" />&nbsp;Add New
                            </CButton>
                          </CCardFooter>
                        </CCard>
                      </CCol>
        </div>
        <div class="md-layout-item md-size-50">
          <md-datepicker v-model="todayDate" />
        </div>
      </div>

     
    </div>
  </div>
</div>
  </div>
</template>
<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import moment from "moment";
import { RadialProgressBar, TimeLine, TimeLineItem } from "@/components";
import CTableWrapper from "../../../tables/Table";
import Swal from "sweetalert2";
import { APIService } from "../../../../apiservice.js";
export default {
  components: {
    VuePerfectScrollbar,
    RadialProgressBar,
    TimeLine,
    TimeLineItem
  },
  data() {
    return {
     
      headercolor: null,
      sidebarcolor: null,
      isConfigOpen: false,
      speciesItem: [],
      editSpecies: [],
      liveWeightfrom: "",
      liveWeightto: "",
      dry: "",
      s_p_fodder: "",
      dryM1: "",
      dryM2: "",
      dryM3: "",
      greenFodder: "",
      addButton: false,
      saveButton: false,
      deleteButton: false,
      addnewButton: true,
      cancelButton: false,
      EditsaveButton: false,
      options: ["Option 1", "Option 2", "Option 3"],
      tabs: ["Body Weight", "Maintance", "Pregnancy Month Wise "],
      fields: [
        {
          label:"check",
          key: "liveWeightfrom,",
          sortable: true,
        },
        {
          key: "liveWeightto",
          sortable: true,
        },
        {
          key: "dry",
          sortable: true,
        },
        {
          key: "s_p_fodder",
          sortable: true,
        },
         {
          key: "dryM1",
          sortable: true
        },
            {
          key: "dryM2",
          sortable: true
        },
          {
          key: "dryM3",
          sortable: true
        },
        {
          key: "greenFodder",
          sortable: true,
        },
      ],
      //   items: [
      //     {
      //       isActive: true,
      //      Live_Weight_kg_From: "1",
      //       Live_Weight: "Murrah",
      //       Dry: "Buffalo",
      //          S_P_Foode: "1",
      //       DRY_M: "Murrah",
      //        DRY_M: "Buffalo",
      //        Green_Fodder: "Buffalo"
      //     },

      //   ],
      //  fields1: [
      //     {
      //       key: "Pregnancy_Days_From",
      //       sortable: true
      //     },
      //     {
      //       key: "Pregnancy_Days_To",
      //       sortable: true
      //     },
      //     {
      //       key: "Dry",
      //       sortable: true
      //     },
      //      {
      //       key: "S_P_Foode",
      //       sortable: true
      //     },
      //      {
      //       key: "DRY_M",
      //       sortable: true
      //     },
      //         {
      //       key: "DRY_M",
      //       sortable: true
      //     },
      //         {
      //       key: "Green_Fodder",
      //       sortable: true
      //     }
      //   ],
      //   items1: [

      //   ],
      //   fields2: [
      //     {
      //       key: "Milk_kg_From",
      //       sortable: true
      //     },
      //     {
      //       key: "Milk_Kg_To",
      //       sortable: true
      //     },
      //     {
      //       key: "Dry",
      //       sortable: true
      //     },
      //      {
      //       key: "S_P_Foode",
      //       sortable: true
      //     },
      //      {
      //       key: "DRY_M",
      //       sortable: true
      //     },
      //         {
      //       key: "DRY_M",
      //       sortable: true
      //     },
      //         {
      //       key: "Green_Fodder",
      //       sortable: true
      //     }
      //   ],
      //   items1: [

      //   ],
    };
  },
  methods: {

    toggleConfig(className) {
      const el = document.body;
      this.isConfigOpen = !this.isConfigOpen;
      if (this.isConfigOpen) {
        el.classList.add(className);
      }
       else {
        el.classList.remove(className);
      }
    },
      getbodyWeightList() {
      APIService.bodyWeightList().then((res) => {
        if (res.status == 200) {
          this.speciesItem = res.data;

          this.liveWeightfrom = this.speciesItem[0].liveWeightfrom + " - " +  this.speciesItem[0].liveWeightto ;
          this.liveWeightto = this.speciesItem[0].liveWeightto;
        
          this.dry = this.speciesItem[0].dry;
          this.s_p_fodder = this.speciesItem[0].s_p_fodder;
          this.dryM1 = this.speciesItem[0].dryM1;
          this.dryM2 = this.speciesItem[0].dryM2;
          this.dryM3 = this.speciesItem[0].dryM3;
          this.greenFodder = this.speciesItem[0].greenFodder;
        }
      });
    },
    rowClicked(item, index, column, e) {
      console.log("edit item", item, index, column, e);
     
      this.editSpecies = item;
      this.liveWeightfrom = item.liveWeightfrom;
      this.liveWeightto = item.liveWeightto;
      this.dry = item.dry;
      this.s_p_fodder = item.s_p_fodder;
      this.dryM1 = item.dryM1;
      this.dryM2 = item.dryM2;
      this.dryM3 = item.dryM3;
      this.greenFodder = item.greenFodder;
      this.addButton = false;
      this.saveButton = true;
      this.deleteButton = true;
      this.cancelButton = false;
      this.addnewButton = true;
      this.EditsaveButton = false

      return this.toggleConfig("settings-open");
    },
    addNewspecies() {
      this.liveWeightfrom = "";
      this.liveWeightto = "";
      this.dry = "";
      this.s_p_fodder = "";
      this.dryM1 = "";
      this.dryM2 = "";
      this.dryM3 = "";
      this.greenFodder = "";
      this.addButton = false;
      this.saveButton = false;
      this.deleteButton = false;
      this.cancelButton = true;
      this.addnewButton = false;
      this.EditsaveButton = true;
      return getbodyWeightList();
    },
    Cancelspecies() {
      this.liveWeightfrom = "";
      this.liveWeightto = "";
      this.dry = "";
      this.s_p_fodder = "";
      this.dryM1 = "";
      this.dryM2 = "";
      this.dryM3 = "";
      this.greenFodder = "";
      this.addButton = false;
      this.saveButton = false;
      this.deleteButton = false;
      this.cancelButton = false;
      this.addnewButton = true;
      (this.EditsaveButton = false), this.getbodyWeightList();
    },

    addSpecies() {
      let liveWeightfrom = this.liveWeightfrom;
      let liveWeightto = this.liveWeightto;
      let dry = this.dry;
      let s_p_fodder = this.s_p_fodder;
      let dryM1 = this.dryM1;
      let dryM2 = this.dryM2;
      let dryM3 = this.dryM3;
      let greenFodder = this.greenFodder;
      let data = {
        liveWeightfrom,
        liveWeightto,
        dry,
        s_p_fodder,
        dryM1,
        dryM2,
        dryM3,
        greenFodder,
      };
      APIService.saveBodyWeight(data).then((res) => {
        if (res.status == 200) {
          (this.liveWeightfrom = ""),
            (this.liveWeightto = ""),
            (this.dry = ""),
            (this.s_p_fodder = ""),
            (this.dryM1 = ""),
            (this.dryM2 = ""),
            (this.dryM3 = ""),
            (this.greenFodder = ""),
            this.getbodyWeightList();
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Data Saved Successfully",
            showConfirmButton: false,
            timer: 2000,
          });
        }
      });
    },
    updateSpecies() {
      let id = this.editSpecies._id;
      let liveWeightfrom = this.liveWeightfrom;
      let liveWeightto = this.liveWeightto;
      let dry = this.dry;
      let s_p_fodder = this.s_p_fodder;
      let dryM1 = this.dryM1;
      let dryM2 = this.dryM2;
      let dryM3 = this.dryM3;
      let greenFodder = this.greenFodder;
      let value = {
        liveWeightfrom,
        liveWeightto,
        dry,
        s_p_fodder,
        dryM1,
        dryM2,
        dryM3,
        greenFodder,
      };
      let data = { id, value };
      APIService.bodyWeightUpdate(data).then((res) => {
        if (res.status == 200) {
          (this.liveWeightfrom = ""),
            (this.liveWeightto = ""),
            (this.dry = ""),
            (this.s_p_fodder = ""),
            (this.dryM1 = ""),
            (this.dryM2 = ""),
            (this.dryM3 = ""),
            (this.greenFodder = ""),
            (this.addButton = false);
          this.saveButton = false;
          this.deleteButton = false;
          this.cancelButton = false;
          this.addnewButton = true;
          this.getbodyWeightList();
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Data Saved Successfully",
            showConfirmButton: false,
            timer: 2000,
          });
        }
      });
    },
    deleteSpecies() {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, delete it!",
          cancelButtonText: "No, cancel!",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.value) {
            swalWithBootstrapButtons.fire(
              "Deleted!",
              "Your file has been deleted.",
              "success"
            );
            this.delete();
          } else if (
            /* Read more about handling dismissals below */
            result.dismiss === Swal.DismissReason.cancel
          ) {
            swalWithBootstrapButtons.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },

    delete() {
      let id = this.editSpecies._id;
      let data = { id };
      APIService.bodyWeightDelete(data).then((res) => {
        if (res.status == 200) {
          (this.liveWeightfrom = ""),
            (this.liveWeightto = ""),
            (this.dry = ""),
            (this.s_p_fodder = ""),
            (this.dryM1 = ""),
            (this.dryM2 = ""),
            (this.dryM3 = ""),
            (this.greenFodder = ""),
            (this.addButton = false);
          this.saveButton = false;
          this.deleteButton = false;
          this.cancelButton = false;
          this.addnewButton = true;
          (this.EditsaveButton = false), this.getbodyWeightList();
        }
      });
    },


  },
  // mounted() {
  //   this.$root.$on("openFixedPlugin", item => {
  //     this.user = item;
  //   this.getbodyWeightList();
  //     this.defaultDate.setHours(0, 0, 0, 0);
  //     this.todayDate = this.defaultDate;
  //     this.isConfigOpen = true;
  //     this.toggleConfig("settings-open");
  //   });

  // },
  
  created() {
    this.getbodyWeightList();
    this.isConfigOpen = true;
    this.toggleConfig("settings-open");
  }
};
</script>
 <style lang="scss" scoped>
.scrollbar-container1 {
  position: relative;
  height: 100%;
}
.btn-warning {
  color: #fff;
  // background-color: #425276;
  border-color: #425276;
}
.btn {
  font-size: 0.94rem;
  font-weight: 500;
}

$theme-options-width: 500px;

.ui-theme-settings {
  position: fixed;
  z-index: 155;
  right: -30px;
  top: 0;
  height: 100vh;
  transform: translate($theme-options-width);
  transition: all 0.2s;
  box-shadow: -0.46875rem 0 2.1875rem rgba(darken(#007bff, 50%), 0.03),
    -0.9375rem 0 1.40625rem rgba(darken(#007bff, 50%), 0.03),
    -0.25rem 0 0.53125rem rgba(darken(#007bff, 50%), 0.05),
    -0.125rem 0 0.1875rem rgba(darken(#007bff, 50%), 0.03);

  .btn-open-options {
    border-radius: 50px;
    position: absolute;
    left: -100px;
    bottom: 40px;
    padding: 0;
    height: auto;
    line-height: 50px;
    width: 54px;
    text-align: center;
    display: block;
    box-shadow: 0 0.46875rem 2.1875rem rgba(darken(#007bff, 50%), 0.03),
      0 0.9375rem 1.40625rem rgba(darken(#007bff, 50%), 0.03),
      0 0.25rem 0.53125rem rgba(darken(#007bff, 50%), 0.05),
      0 0.125rem 0.1875rem rgba(darken(#007bff, 50%), 0.03);
    margin-top: -27px;

    svg {
      top: 50%;
      left: 50%;
      color: white;
      position: absolute;
      margin: -0.5em 0 0 -0.5em;
    }
  }

  .theme-settings__inner {
    background: #f1f1f1;
    width: $theme-options-width;
    height: 100vh;
    padding: 0;
  }

  .theme-settings-swatches {
    text-align: center;

    .swatch-holder-img {
      width: 72px;
      height: auto;
      border-radius: 3px;

      img {
        width: 100%;
      }
    }
  }

  .themeoptions-heading {
    font-size: (1rem * 1.25);
    color: gray;
    margin: 0;
    background: gray;
    padding: (1.5rem / 2) 1.5rem;
    border-bottom: gray solid 1px;
    border-top: gray solid 1px;
    display: flex;
    align-items: center;
    align-content: center;

    &:first-child {
      border-top: 0;
    }
  }

  .list-group-item {
    h5 {
      color: #007bff;
      font-size: (1rem * 0.875);
      text-transform: uppercase;
      margin: 0;
      text-align: center;
    }
  }
}

.settings-open {
  .ui-theme-settings {
    transform: translate(0);
    right: 0;

    .btn-open-options {
      left: -80px;
    }
  }
}

.swatch-holder {
  width: 24px;
  height: 24px;
  line-height: 24px;
  margin: 5px 5px 0;
  transition: all 0.2s;
  opacity: 0.7;
  display: inline-block;
  border-radius: 30px;

  &.active {
    border: #fff solid 2px;
    box-shadow: 0 0 0 5px #007bff;
    opacity: 1;
  }

  &:hover {
    opacity: 1;
  }
}

.swatch-holder-lg {
  width: 48px;
  height: 48px;
  line-height: 48px;
}

.swatch-holder-md {
  width: 30px;
  height: 30px;
  line-height: 30px;
}

.vl {
  border-left: 1px solid black;
  height: auto;
}
</style>

<style >
.timeline.timeline-simple {
  margin-top: 0px !important;
  margin-bottom: 0px !important;
}
.timeline > li {
  margin-bottom: 0px !important;
}
.timeline.timeline-simple:before {
  height: 100%;
}

.lastknown .timeline.timeline-simple:before {
  display: none;
  /* height: 50%; */
}

.badgeVisit {
  border: 2px solid rgb(76, 175, 80);
  color: #000000;
  font-size: 11px;
}
.badgePunchIn {
  border: 2px solid rgb(244, 67, 54);
  color: #000000;
  font-size: 11px;
}

.badgePunchOut {
  border: 2px solid rgb(244, 67, 54);
  color: #000000;
  font-size: 11px;
}
.badgeLastKnown {
  border: 2px solid rgb(0, 188, 212);
  color: #000000;
  font-size: 11px;
}
</style>